import React from 'react'
import styled from 'styled-components'

import { SanityCheckoutMarketingContentFragment } from '../../../graphql/gatsby'
import { BannerWithText } from '../../sanity-page/BannerWithText'

const Container = styled.div`
  width: 100%;
`

export interface ConfirmationMarketingContentProps {
  checkoutMarketingContent: SanityCheckoutMarketingContentFragment['sanityCheckoutMarketingContent']
}

const ConfirmationMarketingContent: React.FC<ConfirmationMarketingContentProps> = ({
  checkoutMarketingContent,
}) => {
  const { confirmationBanners } = checkoutMarketingContent || {}
  if (!confirmationBanners) return null
  return (
    <Container>
      {confirmationBanners.length > 0 &&
        confirmationBanners.map((confirmationBanner, index) => {
          if (!confirmationBanner) return null
          return (
            <BannerWithText
              key={index}
              backgroundStyles={confirmationBanner.backgroundStyles}
              heroImage={confirmationBanner.heroImage}
              heroImageMobile={confirmationBanner.heroImageMobile}
              content={confirmationBanner._rawContent}
              textBackgroundColor={confirmationBanner.textBackgroundColor}
              textPosition={confirmationBanner.textPosition}
              textStyles={confirmationBanner.textStyles}
              cta={confirmationBanner.cta}
              ctaBackgroundColor={confirmationBanner.ctaBackgroundColor}
              ctaTextColor={confirmationBanner.ctaTextColor}
              roleBasedContent={confirmationBanner.roleBasedContent}
              contextBasedContent={confirmationBanner.contextBasedContent}
            />
          )
        })}
    </Container>
  )
}

export default ConfirmationMarketingContent
